// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
const { Provider } = require('react-redux')
const Router = typeof window === 'undefined'
? require('client-v2/common/state/router/components/connected-memory-router')
: require('react-router-dom').BrowserRouter
// Common V2 imports
const ErrorBoundary = require('client-v2/common/components/error-boundary')

// This propagates Redux and Router state down to child components
// The actual markup is represented in the layout component

module.exports = function (WrappedComponent) {
  function RootComponent(props) {
    return (
      React.createElement(ErrorBoundary, null,
        React.createElement(Provider, { store: props.store },
          React.createElement(Router, null,
            React.createElement(WrappedComponent)
          )
        )
      )
    )
  }

  RootComponent.propTypes = {
    store: PropTypes.object.isRequired
  }

  RootComponent.factory = React.createFactory(RootComponent)

  return RootComponent
}
